import Table from "components/Table";
import { SearchResultTableColumn } from "./SearchResult/constants";
import { ReactNode } from "react";

const TableResultsSection = ({
  tableColumns,
  children,
}: {
  tableColumns: SearchResultTableColumn[];
  children: ReactNode;
}) => {
  return (
    <Table
      scrollable
      className="pt-4 overflow-y-hidden" // Should never be scrollable vertically
      scrollAreaClassName="pl-[var(--main-col-gutter-width)] overflow-y-hidden" // Should never be scrollable vertically
      data-testid="search-results-list"
      data-table-container
    >
      <Table.THead>
        <Table.TR>
          {tableColumns.map((column) => (
            <Table.TH
              key={column.id}
              className={
                column.id === "paper"
                  ? "min-w-[var(--result-table-paper-col-width)]"
                  : column.id === "answer"
                    ? "min-w-[var(--result-table-answer-col-width)]"
                    : "min-w-[var(--result-table-default-col-width)]"
              }
            >
              {column.title}
            </Table.TH>
          ))}
        </Table.TR>
      </Table.THead>
      {children}
    </Table>
  );
};

export default TableResultsSection;
